export default [
    {
      path: '/draw/:type',
      name: 'draw',
      meta: {
        title: '幸运转盘'
      },
      component: () => import('./Draw')
    },
    {
        path: '/drawrecord',
        name: 'draw.record',
        meta: {
            title: '参与记录'
        },
        component: () => import('./Record')
    }
]